module.exports = __webpack_public_path__ + "7bd1c1d4b45f07837383669977df677f.svg";